export const standardizeVersion = appVer => {
    const appVersionLength = appVer.split('.').length;

    if (appVersionLength === 1) {
        return `${appVer}.0.0`;
    }

    if (appVersionLength === 2) {
        return `${appVer}.0`;
    }

    return appVer;
};
